export class SchedulerData {

    schedulers: Scheduler[] = [];
    clientId: string;
    projectId: string;
    batches: number[] = [];
    fromDate: string;
    toDate: string;
    targetCalls: number;
    targetSchedules: number;
    updatedBy: string;

}

export class Scheduler {

    id: number;
    schedulerId: number;
    schedulerName: string;
    firstName: string;
    lastName: string;
    clientId: string;
	clientName: string;
	projectId: string;
    projectIds: number[]=[];
	projectName: string;
    assignedProjectNames: string;
    assignedBatches: any[];
    contactNumber: string;
    address1: string;
	address2: string;
	state: string;
	city: string;
    zip: string;
    isAssigned: boolean;
    assignChanged: boolean = false;
    updatedBy: string;

}

export class batches {

   // projectId: string;
    batches: any [];

}

export class AssignScheduler {
    clientId: number;
    schedulerId: number;
    projectIds: number[]=[];
    isAssigned: boolean;
    updatedBy: string;
}